// tilesConfig.js - Centralized configuration for all application modules/tiles
// lalit
const hideForUsers = ["6630b1321433a777c3031e7b"]

export const ADMIN_TILES = [
  {
    id: 1,
    name: 'Add Part',
    displayText: { first: 'Add', second: 'Part' },
    icon: '📝',
    route: '/part_list',
    color: 'maroon',
    userType: 2,
    hideForUsers
  },
  {
    id: 2,
    name: 'Annexure Management',
    displayText: { first: 'ANNEXURE', second: 'MANAGEMENT' },
    icon: '📋',
    route: '/annexure_management',
    color: 'maroon',
    userType: 2,
    hideForUsers
  },
  {
    id: 3,
    name: 'View Documents',
    displayText: { first: 'View', second: 'Documents' },
    icon: '👁️',
    route: '/viewPartTable',
    color: '#054a29',
    userType: 2,
    hideForUsers
  },
  {
    id: 4,
    name: 'Annual Process & Product Audit',
    displayText: { first: 'Annual Process &', second: 'Product Audit' },
    icon: '📊',
    route: 'https://slf.secure.aqua.mushinlabs.com/common/annualPmPlanUtilityTiles',
    isExternal: true,
    color: '#003566',
    userType: 2,
    hideForUsers

  },
  {
    id: 5,
    name: 'FMEA Management',
    displayText: { first: 'FMEA', second: 'MANAGEMENT' },
    icon: '🏢',
    route: '/fmeamanagement',
    color: '#003566',
    userType: 2,

    hideForUsers
  },
  {
    id: 6,
    name: 'Master Formats',
    displayText: { first: 'Master', second: 'Formats' },
    icon: '📄',
    route: '/masterFormatDocumentTile',
    color: '#003566',
    userType: 2,
    hideForUsers
  },
  {
    id: 7,
    name: 'Raw Material Receiving',
    displayText: { first: 'Raw Material', second: 'Receiving' },
    icon: '🌲',
    route: '/rmpartlist',
    color: '#003566',
    userType: 2,
    sharedWithSupervisor: true,

    hideForUsers
  },
  {
    id: 8,
    name: 'Item Master',
    displayText: { first: 'Item', second: 'Master' },
    icon: '📑',
    route: '/listMasterList',
    color: 'black',
    userType: 2,
  },
  {
    id: 9,
    name: 'Master List of Instruments',
    displayText: { first: 'Master List of', second: 'Instruments' },
    icon: '🎛️',
    route: 'https://slf.secure.aqua.mushinlabs.com/common/instrumentMasterlist',
    isExternal: true,
    color: '#003566',
    userType: 2,
    hideForUsers
  },
  {
    id: 10,
    name: 'Obsolete Instruments',
    displayText: { first: 'Master List of', second: 'Obsolete Instruments' },
    icon: '🔧',
    route: 'https://slf.secure.aqua.mushinlabs.com/common/obsoleteInstrumentMasterlist',
    isExternal: true,
    color: '#003566',
    userType: 2,
    hideForUsers
  },
  {
    id: 11,
    name: 'Calibration Plan',
    displayText: { first: 'CALLIBRATION', second: 'PLAN' },
    icon: '📚',
    route: 'https://slf.secure.aqua.mushinlabs.com/common/tilesCallibrationplan',
    isExternal: true,
    color: '#003566',
    userType: 2,

    hideForUsers
  },
  {
    id: 12,
    name: 'Manage Location',
    displayText: { first: 'Manage', second: 'Location' },
    icon: '📍',
    route: 'https://slf.secure.aqua.mushinlabs.com/common/masterListLocationList',
    isExternal: true,
    color: '#003566',
    userType: 2,
    hideForUsers
  },
  {
    id: 13,
    name: 'Approved External Providers',
    displayText: { first: 'APPROVED EXTERNAL', second: 'PROVIDERS' },
    icon: '📃',
    route: 'https://slf.secure.aqua.mushinlabs.com/common/masterListApprovedExternalProvederList',
    isExternal: true,
    color: '#003566',
    userType: 2,
    hideForUsers
  },
  {
    id: 14,
    name: 'SPC Report',
    displayText: { first: 'SPC', second: 'REPORT' },
    icon: '📈',
    route: 'https://slf.secure.aqua.mushinlabs.com/common/spcPlanTiles',
    isExternal: true,
    color: '#003566',
    userType: 2,
    hideForUsers
  },
  {
    id: 15,
    name: 'MSA Report',
    displayText: { first: 'MSA', second: 'REPORT' },
    icon: '📉',
    route: 'https://slf.secure.aqua.mushinlabs.com/common/tilesMsaplan',
    isExternal: true,
    color: '#003566',
    userType: 2,
    hideForUsers
  },
  {
    id: 16,
    name: 'Abnormality Handling Report',
    displayText: { first: 'ABNORMALITY HANDLING', second: 'REPORT' },
    icon: '⚠️',
    route: 'https://slf.secure.aqua.mushinlabs.com/common/abnormalityHandling',
    isExternal: true,
    color: '#003566',
    userType: 2,
    sharedWithSupervisor: true,
    hideForUsers
  },
  {
    id: 17,
    name: 'Quality Department Upload',
    displayText: { first: 'QUALITY DEPARTMENT', second: 'UPLOAD' },
    icon: '☁️',
    route: 'https://slf.secure.aqua.mushinlabs.com/common/qualityDepartmentUpload/?documentType=qualityDmsUpload&heading=QUALITY DMS UPLOAD',
    isExternal: true,
    color: '#003566',
    userType: 2,
    hideForUsers
  },
  {
    id: 18,
    name: 'Master List of Device',
    displayText: { first: 'Master List of', second: 'Device' },
    icon: '💻',
    route: '/deviceList',
    color: 'maroon',
    userType: 2,
  },
  {
    id: 19,
    name: 'Mushin Aqua Masters',
    displayText: { first: 'MUSHIN AQUA', second: 'MASTERS' },
    icon: '📱',
    route: 'https://slf.secure.aqua.mushinlabs.com/common/mushinAquaMastersTiles',
    isExternal: true,
    color: 'maroon',
    userType: 2,
  },
  {
    id: 20,
    name: 'Mushin Help Desk',
    displayText: { first: 'MUSHIN HELP', second: 'DESK' },
    icon: '❓',
    route: 'https://slf.secure.aqua.mushinlabs.com/common/mushinHelpDesk',
    isExternal: true,
    color: '#003566',
    userType: 2,
  },
  {
    id: 31,
    name: 'HR Department',
    displayText: { first: 'HR', second: 'DEPARTMENT' },
    icon: '👥',
    route: 'https://slf.secure.aqua.mushinlabs.com/admin/clause5',
    isExternal: true,
    color: '#054a29',
    userType: 2,
  },
  {
    id: 32,
    name: 'Production Department',
    displayText: { first: 'PRODUCTION', second: 'DEPARTMENT' },
    icon: '🏭',
    route: 'https://slf.secure.aqua.mushinlabs.com/common/productionAndMaintenaceHome',
    isExternal: true,
    color: '#003566',
    userType: 2,
  },
  {
    id: 33,
    name: 'Maintenance Department',
    displayText: { first: 'Maintenance', second: 'Department' },
    icon: '🔧',
    route: 'https://slf.secure.aqua.mushinlabs.com/admin/clause10',
    isExternal: true,
    color: '#003566',
    userType: 2,
  },
  {
    id: 34,
    name: 'Pending Inspection & Setup Reports',
    displayText: { first: 'PENDING INSPECTION', second: '& SETUP REPORTS' },
    icon: '📋',
    route: '/viewAllPirTableList',
    color: '#003566',
    userType: 2,
    hideForUsers
  },
  {
    id: 35,
    name: 'RM Reports',
    displayText: { first: 'RM', second: 'REPORTS' },
    icon: '📊',
    route: '/viewAllRmTableList',
    color: '#003566',
    userType: 2,
    hideForUsers
  },
  {
    id: 36,
    name: 'Quality Department',
    displayText: { first: 'Quality', second: 'Department' },
    icon: '📊',
    route: '/qualityDepartment',
    color: '#003566',
    userType: 2
  },
  {
    id: 37,
    name: 'TOOL ROOM',
    displayText: { first: 'TOOL', second: 'ROOM' },
    icon: '🔧',
    route: 'https://slf.secure.aqua.mushinlabs.com/common/toolRoomTiles',
    isExternal: true,
    color: '#003566',
    userType: 2,
    hideForUsers
  }
];

export const SUPERVISOR_TILES = [
  {
    id: 21,
    name: 'Control Plan',
    displayText: { first: 'Control', second: 'Plan' },
    icon: '📝',
    route: '/supervisor/viewparttable/controlplan',
    color: 'maroon',
    userType: 3
  },
  {
    id: 22,
    name: 'Inspection & Setup Reports',
    displayText: { first: 'Inspection & Setup', second: 'Reports' },
    icon: '✅',
    route: '/supervisor/viewparttable/pir',
    color: '#003566',
    userType: 3
  },
  {
    id: 23,
    name: 'Pre-dispatch Inspection Reports',
    displayText: { first: 'Pre-dispatch', second: 'Inspection Reports' },
    icon: '🚚',
    route: '/supervisor/viewparttable/pdir',
    color: '#003566',
    userType: 3
  },
  {
    id: 24,
    name: 'SOP Module',
    displayText: { first: 'SOP', second: 'Module' },
    icon: '📖',
    route: '/supervisor/viewparttable/sop',
    color: '#003566',
    userType: 3
  },
  {
    id: 25,
    name: 'Material TC',
    displayText: { first: 'Material', second: 'TC' },
    icon: '📊',
    route: '/materialTc/table',
    color: '#003566',
    userType: 3
  },
  {
    id: 26,
    name: 'Saved Inspection & Setup Reports',
    displayText: { first: 'SAVED Inspection', second: '& Setup Reports' },
    icon: '💾',
    route: '/viewAllPirTableList',
    color: '#003566',
    userType: 3
  },
  {
    id: 27,
    name: 'Saved RM Reports',
    displayText: { first: 'SAVED RM', second: 'Reports' },
    icon: '📁',
    route: '/viewAllRmTableList',
    color: '#003566',
    userType: 3
  }
];

// Combine all tiles and automatically remove duplicates (keeping first occurrence)
const combineAndDeduplicateTiles = () => {
  const allTiles = [...ADMIN_TILES, ...SUPERVISOR_TILES];
  const uniqueTilesMap = new Map();

  allTiles.forEach(tile => {
    if (!uniqueTilesMap.has(tile.id)) {
      uniqueTilesMap.set(tile.id, tile);
    }
  });

  return Array.from(uniqueTilesMap.values());
};

// Export unique tiles (duplicates automatically removed)
export const UNIQUE_TILES = combineAndDeduplicateTiles();

// Get tiles by user type (including shared tiles)
export const getTilesByUserType = (userType) => {
  if (userType === 2) {
    return ADMIN_TILES;
  } else if (userType === 3) {
    // For supervisors, include supervisor tiles plus shared admin tiles (7, 16)
    const sharedAdminTiles = ADMIN_TILES.filter(tile =>
      tile.sharedWithSupervisor && (tile.id === 7 || tile.id === 16)
    );
    return [...SUPERVISOR_TILES, ...sharedAdminTiles];
  }
  return [];
};

// Get tile by ID from unique tiles
export const getTileById = (id) => {
  return UNIQUE_TILES.find(tile => tile.id === id);
};

// Available permission types
export const PERMISSION_TYPES = ['view', 'edit', 'delete', 'create'];

// User type labels
export const USER_TYPE_LABELS = {
  1: { label: 'User', type: 'user' },
  2: { label: 'Admin', type: 'admin' },
  3: { label: 'Supervisor', type: 'supervisor' }
};

// Validation result (for informational purposes only, no errors thrown)
export const VALIDATION_RESULT = {
  isValid: true,
  totalTiles: UNIQUE_TILES.length,
  adminTiles: ADMIN_TILES.length,
  supervisorTiles: SUPERVISOR_TILES.length,
  message: `Configuration loaded: ${UNIQUE_TILES.length} unique tiles`
};

// Log configuration summary (no errors, just info)
console.log(`✅ Tiles Configuration Loaded:`, VALIDATION_RESULT);
